export const CONSENT_KEY = "parberkon_cookie_consent";

export interface ConsentPreferences {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
  preferences: boolean;
}

export function getStoredConsent(): ConsentPreferences | null {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed.preferences ?? null;
  } catch {
    return null;
  }
}

export function dispatchConsentUpdate(preferences: ConsentPreferences): void {
  window.dispatchEvent(
    new CustomEvent("cookie-consent-update", { detail: preferences })
  );
}
